import React from "react";
import styles from "./Card.module.css";

function Card(props) {
  return (
    <div className={styles.card + (props.className ? ' ' + props.className : '')} style={{...props.style}} onClick={props.onClick}>
      {props.children}
    </div>
  );
}

export default Card;